import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { OrderTypeToColor } from './OrgDashboard';
// this is old react router dom
import { ArrowUpRightCircle } from 'react-bootstrap-icons';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function StatsPiCard({
  title,
  totalCount,
  groupData,
  icon,
  type = 'number',
  cancellationRate,
  columnClass = 'col-12 col-md-4 mb-3',
  columnStyle
}) {
  const chartData =
    // to show empty state
    totalCount === 0
      ? {
          labels: ['No Data'],
          datasets: [
            {
              data: [1], // Single data point to create a full circle
              backgroundColor: ['#E5E7EB'], // Light gray color
              borderColor: ['#E5E7EB'],
              borderWidth: 0,
              cutout: '50%'
            }
          ]
        }
      : {
          labels: groupData.length > 0 ? groupData.map(item => item._id) : ['No Data'],
          datasets: [
            {
              data: groupData.length > 0 ? groupData.map(item => item.count) : [0],
              backgroundColor:
                groupData.length > 0 ? groupData.map(item => OrderTypeToColor[item._id] || '#6B7280') : ['#E5E7EB'],
              borderColor:
                groupData.length > 0 ? groupData.map(item => OrderTypeToColor[item._id] || '#6B7280') : ['#E5E7EB'],
              borderWidth: 0,
              cutout: '50%'
            }
          ]
        };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: totalCount > 0, // Disable tooltip for empty state
        callbacks: {
          title: function(context) {
            return context[0].label || '';
          },
          label: function(context) {
            const value = context.parsed;
            return ` Count: ${value}`;
          }
        },
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 6,
        padding: 4,
        displayColors: true
      },
      datalabels: {
        display: false
      }
    },
    interaction: {
      intersect: false,
      mode: 'nearest'
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart',
      animateRotate: true,
      animateScale: true
    },
    hover: {
      mode: 'nearest',
      intersect: false,
      animationDuration: 300
    },
    elements: {
      arc: {
        hoverOffset: totalCount > 0 ? 4 : 0, // No hover effect for empty state
        borderWidth: 0
      }
    }
  };

  return (
    <div className={columnClass} style={columnStyle}>
      <div className="card shadow-sm rounded h-100">
        <div className="card-body d-flex flex-column justify-content-between px-3 py-2">
          <div className="d-flex justify-content-between align-items-start mb-2" style={{ gap: '8px', minWidth: 0 }}>
            <div className="d-flex flex-column" style={{ flex: '1 1 auto', minWidth: 0 }}>
              <div className="d-flex align-items-start mb-2" style={{ gap: '8px', minWidth: 0 }}>
                <div style={{ flexShrink: 0, marginTop: '2px' }}>{icon}</div>
                <h6 className="fw-semibold mb-0" style={{ fontSize: '0.8125rem', lineHeight: 1.35, minWidth: 0 }}>
                  {title}
                </h6>
              </div>
              <h1
                className="mb-0"
                style={{ fontWeight: '800', fontSize: 'clamp(1.5rem, 4vw, 2.2rem)', lineHeight: '1', color: '#212529' }}
              >
                {type === 'percentage' ? `${cancellationRate}%` : totalCount}
              </h1>
            </div>
            <div style={{ height: '72px', width: '72px', position: 'relative', flexShrink: 0 }}>
              <Pie data={chartData} options={chartOptions} aria-hidden="true" />
            </div>
          </div>

          <div className="mt-1">
            <div className="d-flex flex-wrap" style={{ gap: '6px' }}>
              {Object.keys(OrderTypeToColor).map(orderType => {
                const item = groupData.find(g => g._id === orderType);
                const count = item ? item.count : 0;
                const percentage = item ? item.percent : 0;

                return (
                  <div key={orderType} style={{ flex: '1 1 calc(33.333% - 6px)', minWidth: '88px' }}>
                    <div
                      className="text-center rounded py-2 px-1"
                      style={{
                        backgroundColor: `${OrderTypeToColor[orderType]}28`
                      }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="d-flex align-items-center justify-content-center mb-1">
                          <div
                            className="rounded-circle"
                            style={{
                              width: '8px',
                              height: '8px',
                              marginRight: '4px',
                              backgroundColor: OrderTypeToColor[orderType],
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}
                          />
                          <small className="text-muted text-truncate" style={{ fontSize: '0.6875rem', maxWidth: '100%' }}>
                            {orderType}
                          </small>
                        </div>
                        <div className="fw-bold text-dark" style={{ fontSize: '0.8125rem' }}>
                          {type === 'percentage' ? `${percentage}%` : count}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
